import styles from "./WaitlistClient.module.scss";
import { ReactComponent as OutlineClock } from "assets/svg/outline-clock.svg";

interface WaitlistClientProps {
  message: string;
}

const WaitlistClient = ({ message }: WaitlistClientProps) => (
  <div className={styles["warning"]}>
    <div className={styles["warning__icon"]}>
      <OutlineClock />
    </div>
    {message}
  </div>
);

export default WaitlistClient;
